import { PriceableItemOrigin } from "elephant-web/gql";
import { sortFilterAndPaginate } from "./helpers";
import type {
  SearchNewItemData,
  SearchNewItemHookResult,
  SearchNewItemParams,
} from "./types";

export enum GENERAL {
  CONSULTATION = "Consultation",
  ELEPHANT_REGISTRATION = "Elephant Registration",
  INPATIENT_ADMISSION = "Inpatient Admission",
}

export const generalItems = [
  {
    id: "7d2f0794-807a-4a3e-bc50-9a98c60a8bf0", // generated with https://www.uuidgenerator.net/version4
    name: GENERAL.CONSULTATION,
    origin: PriceableItemOrigin.General,
  },
  {
    id: "18c0c6a3-f4bc-4bfe-8d40-2865980dcaed", // generated with https://www.uuidgenerator.net/version4
    name: GENERAL.ELEPHANT_REGISTRATION,
    origin: PriceableItemOrigin.General,
  },
  {
    id: "e03f2196-157d-4b64-ad52-fa6b7cf37110s", // generated with https://www.uuidgenerator.net/version4
    name: GENERAL.INPATIENT_ADMISSION,
    origin: PriceableItemOrigin.General,
  },
];

const mapResponseToResult = (
  params?: SearchNewItemParams,
): SearchNewItemData => {
  // filter and sort only if search bar is being used
  const items = params?.variables?.name
    ? sortFilterAndPaginate(generalItems, params)
    : generalItems;

  const data = {
    rows: items,
    totalRows: items.length,
  };
  return { data, loading: false, error: undefined };
};

const useSearchGeneralItemResult: SearchNewItemHookResult = [
  async (args) => mapResponseToResult(args),
  mapResponseToResult(),
];

export default useSearchGeneralItemResult;
